/**
 * Formatter
 */
export * from './formatter/html-formatter';
export * from './formatter/formatter';
export * from './formatter/markdown-formatter';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-richtexteditor/src/rich-text-editor/formatter.js
// module id = 1166
// module chunks = 0